import React from "react";

interface ProductInfoTabProps {
  data: any;
  onChange: (field: string, value: any) => void;
  isEdit: boolean;
  onUpdate?: () => void;
  isLoading?: boolean;
}

const formStyles = {
  lableStyle: "block text-sm text-[#3F5260] font-medium mb-1",
  inputStyle:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm",
  textAreaStyle:
    "w-full px-3 py-2 border border-[#D0D5DE] outline-none rounded-lg focus:ring-1 focus:ring-emerald-500 text-sm h-24 resize-none",
};

export const ProductInfoTab: React.FC<ProductInfoTabProps> = ({
  data,
  onChange,
  isEdit,
  onUpdate,
  isLoading,
}) => {
  const fields = [
    { key: "introduction", label: "Introduction" },
    { key: "howToUse", label: "How To Use" },
    { key: "safetyAdvise", label: "Safety Advise" },
    { key: "ifMiss", label: "If Missed" },
    { key: "factBox", label: "Fact Box" },
    { key: "primaryUse", label: "Primary Use" },
    { key: "storage", label: "Storage" },
    { key: "commonSideEffect", label: "Common Side Effects" },
    { key: "alcoholInteraction", label: "Alcohol Interaction" },
    { key: "pregnancyInteraction", label: "Pregnancy Interaction" },
    { key: "lactationInteraction", label: "Lactation Interaction" },
    { key: "drivingInteraction", label: "Driving Interaction" },
    { key: "kidneyInteraction", label: "Kidney Interaction" },
    { key: "liverInteraction", label: "Liver Interaction" },
    { key: "qAndA", label: "Q & A" },
    { key: "howItWorks", label: "How It Works" },
    { key: "interaction", label: "Interactions" },
    { key: "keyIngredients", label: "Key Ingredients" },
    { key: "keyBenefits", label: "Key Benefits" },
    { key: "productHighlights", label: "Product Highlights" },
    { key: "source", label: "Source" },
  ];

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 h-[60vh] overflow-y-auto pr-2">
        {fields.map((field) => (
          <div key={field.key}>
            <label className={formStyles.lableStyle}>{field.label}</label>
            <textarea
              value={data[field.key] || ""}
              onChange={(e) => onChange(field.key, e.target.value)}
              className={formStyles.textAreaStyle}
              placeholder={`Enter ${field.label}`}
            />
          </div>
        ))}
      </div>

      {isEdit && (
        <div className="flex justify-end mt-6 pt-4 border-t border-gray-200">
          <button
            type="button"
            onClick={onUpdate}
            disabled={isLoading}
            className="px-6 py-2 bg-emerald-600 text-white rounded-lg hover:bg-emerald-700 transition"
          >
            {isLoading ? "Updating..." : "Update Info"}
          </button>
        </div>
      )}
    </div>
  );
};
